import config from "../config";

export function getApiPath() {
  return `${config.apiPath}/graphql.api`;
}

export function getSourcesApiPath() {
  return `${config.apiPath}/source.api`;
}
